var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 12H21M3 12C3 16.9706 7.02944 21 12 21M3 12C3 7.02944 7.02944 3 12 3M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M12 21C4.75561 13.08 8.98151 5.7 12 3M12 21C19.2444 13.08 15.0185 5.7 12 3","stroke":"#000000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Globe.defaultProps = {"width":"800px","height":"800px","viewBox":"0 0 24 24","fill":"none"};

module.exports = Globe;

Globe.default = Globe;
